import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import './MyNavbar.css';

const MyNavbar = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <Navbar 
        fixed="top" 
        collapseOnSelect 
        expand="md" 
        variant="dark" 
        className="animate-navbar nav-theme"
        expanded={expanded}
        onToggle={(expand) => setExpanded(expand)}
      >
        <Container>
          <Navbar.Brand className="my-name"><span>JAKIA</span></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" className="custom-toggler">
            <div className={`hamburger-icon ${expanded ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </Navbar.Toggle>
          <Navbar.Collapse id="responsive-navbar-nav" className="custom-collapse">
            <Nav className="ms-auto" onClick={() => setExpanded(false)}>
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/#about">About</Nav.Link>
              <Nav.Link href="/#Skills">Skills</Nav.Link>
              <Nav.Link href="/#experience">Experience</Nav.Link>
              <Nav.Link href="/projects">Projects</Nav.Link>
              {/* <Nav.Link href="/blogs">Blogs</Nav.Link> */}
              <Nav.Link href="/#contact">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default MyNavbar;
